import React from 'react';
import { GenericSelect } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';
import { CASH_DEPOSIT_CONTENT } from './DropdownContent';

const PaymentTypeCashDeposit = () => (
  <Content>
    {({ accountDetailsPaymentCashInfo = '', accountDetailsFormErrorSelect = '' }) => (
      <Field name="cashDeposit" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            inputId="cashDeposit"
            title={accountDetailsPaymentCashInfo}
            validationMessage={touched && !!error ? accountDetailsFormErrorSelect : ''}
          >
            <Field name="cashDeposit" validate={isRequired} component="select">
              {({ input }) => (
                <GenericSelect
                  name="cashDeposit"
                  {...input}
                  items={CASH_DEPOSIT_CONTENT}
                  selectedId={!input.value ? null : input.value}
                  onChange={selectedId => {
                    input.onChange(selectedId);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);
export default PaymentTypeCashDeposit;
